import React from 'react';
import Classes from '../ProfileSidebar.scss';

const ProfileImage = ({ logoImage, sellerTitle }: { logoImage: string; sellerTitle: string }) => (
  <div className={Classes.profileImageWrap}>
    <img src={logoImage} alt={sellerTitle} className={Classes.profileImage} />
  </div>
);

export default ProfileImage;
